// Simplified-Chinese strings shared across the app: navigation, the app/admin shells, generic
// UI verbs, and form controls. Keys are the exact English source strings (natural keys).
export const common: Record<string, string> = {
  // Brand / shell
  Pinpoint: 'Pinpoint',
  Workspace: '工作区',
  Learning: '学习',
  Home: '首页',
  Library: '视频库',
  Notes: '笔记',
  Athletes: '运动员',
  Categories: '分类',
  Tags: '标签',
  More: '更多',
  'Search notes…': '搜索笔记…',
  'Switch workspace': '切换工作区',
  'No workspace': '暂无工作区',
  'New workspace': '新建工作区',
  'Workspace name': '工作区名称',
  current: '当前',
  'Sign out': '退出登录',
  Language: '语言',

  // Impersonation banner (admin acting as a user)
  'Viewing as {email}': '正在以 {email} 的身份浏览',
  'Stop impersonating': '停止模拟',

  // Generic verbs / actions
  Save: '保存',
  Cancel: '取消',
  Create: '创建',
  Delete: '删除',
  Edit: '编辑',
  Rename: '重命名',
  Remove: '移除',
  Add: '添加',
  Done: '完成',
  Close: '关闭',
  Back: '返回',
  Open: '打开',
  Manage: '管理',
  Confirm: '确认',
  Next: '下一步',
  Previous: '上一步',
  Loading: '加载中',
  'Loading…': '加载中…',
  Search: '搜索',
  All: '全部',
  None: '无',
  Yes: '是',
  No: '否',
}
